<template>
  <div>
    <div class="bar" @click="addPoint($event)" :style="getGradientStyle">
      <div
          v-for="(point, index) in getPoints"
          :key="index"
          class="point"
          :class="point.id === selectedPoint.id ? 'selected-point' : ''"
          :style="{ left: `${point.position}%` }"
          @mousedown="startDrag(index, point)"
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    activeObject:{
      type: Object,
      default: {}
    },
    color: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isDragging: false,
      selectedPoint: null,
      barWidth: 0,
    };
  },
  beforeMount(){
    this.selectedPoint = this.activeObject.gradient.colors.find((point) => point.isSelected);
  },
  computed:{
    getGradientStyle() {
      const style = {
        marginTop: '10px',
        background: this.getGradientString(this.activeObject.gradient.colors)
      }
      return style;
    },
    getPoints() {
      return this.activeObject.gradient.colors.slice().sort((a, b) => a.position - b.position);
    }
  },
  methods: {
    getGradientString(colors) {
      const gradientStops = colors
          .sort((a, b) => a.position - b.position)
          .map(color => `${color.rgba} ${color.position}%`)
          .join(', ');
      return `linear-gradient(90deg, ${gradientStops})`;
    },
    addPoint(event) {
      if (this.isDragging) {
        this.isDragging = false;
        return;
      }
      this.barWidth = event.currentTarget.offsetWidth;
      const clickPosition = event.offsetX;
      const positionPercentage = (clickPosition / this.barWidth) * 100;

      /*this.pointArray.push({
        position: positionPercentage.toFixed(2),
        color: 'blue',
      });*/
    },
    startDrag(index) {
      this.$emit('updateSelectedPointOfGradient', index);
      this.selectedPoint = this.activeObject.gradient.colors.find((point) => point.isSelected);
      this.isDragging = true;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      const bar = document.querySelector('.bar');
      const barRect = bar.getBoundingClientRect();

      const mousePosition = event.clientX - barRect.left;
      let newPosition = (mousePosition / barRect.width) * 100;

      if (newPosition < 0) newPosition = 0;
      if (newPosition > 100) newPosition = 100;

      this.selectedPoint.position = newPosition.toFixed(2);
      this.$emit('updateSelectedPointPosition', this.selectedPoint.position);
    },
    stopDrag() {
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
  },
};
</script>

<style scoped>
.bar {
  position: relative;
  width: 100%;
  height: 24px;
  background-color: lightgray;
  border-radius: 4px;
}

.point {
  position: absolute;
  width: 6px;
  height: 34px;
  border: 1px solid black;
  border-radius: 4px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.selected-point {
  background: black;
}
</style>
